import { ref as f, inject as _, computed as o, nextTick as b } from "vue";
import { getValidDateOfYear as j, getValidDateOfMonth as x } from "./index862.js";
import { PICKER_BASE_INJECTION_KEY as K } from "./index579.js";
import { useLocale as N } from "./index597.js";
const T = (h, L, c, i) => {
  const l = f("date"), d = f(), u = f("date"), v = f(), R = _(K), { disabledDate: m } = R.props, { t: $, lang: y } = N(), P = o(() => c.value.year()), C = o(() => c.value.month()), g = o(() => i.value.year()), M = o(() => i.value.month());
  function w(e, n) {
    const a = $("el.datepicker.year");
    if (e.value === "year") {
      const t = Math.floor(n.value / 10) * 10;
      return a ? `${t} ${a} - ${t + 9} ${a}` : `${t} - ${t + 9}`;
    }
    return `${n.value} ${a}`;
  }
  function k(e) {
    e?.focus();
  }
  async function Y(e, n) {
    if (h.disabled) return;
    const a = e === "left" ? l : u, t = e === "left" ? d : v;
    a.value = n, await b(), k(t.value);
  }
  async function s(e, n, a) {
    if (h.disabled) return;
    const t = n === "left", r = t ? c : i, E = t ? i : c, B = t ? l : u, I = t ? d : v;
    if (e === "year") {
      const O = r.value.year(a);
      r.value = j(O, y.value, m);
    }
    e === "month" && (r.value = x(
      r.value,
      r.value.year(),
      a,
      y.value,
      m
    )), h.unlinkPanels || (E.value = n === "left" ? r.value.add(1, "month") : r.value.subtract(1, "month")), B.value = e === "year" ? "month" : "date", await b(), k(I.value), V(e);
  }
  function V(e) {
    L(
      "panel-change",
      [c.value.toDate(), i.value.toDate()],
      e
    );
  }
  function p(e, n, a) {
    const t = a ? "add" : "subtract";
    return e === "year" ? n[t](10, "year") : n[t](1, "year");
  }
  return {
    leftCurrentView: l,
    rightCurrentView: u,
    leftCurrentViewRef: d,
    rightCurrentViewRef: v,
    leftYear: P,
    rightYear: g,
    leftMonth: C,
    rightMonth: M,
    leftYearLabel: o(() => w(l, P)),
    rightYearLabel: o(
      () => w(u, g)
    ),
    showLeftPicker: (e) => Y("left", e),
    showRightPicker: (e) => Y("right", e),
    handleLeftYearPick: (e) => s("year", "left", e),
    handleRightYearPick: (e) => s("year", "right", e),
    handleLeftMonthPick: (e) => s("month", "left", e),
    handleRightMonthPick: (e) => s("month", "right", e),
    handlePanelChange: V,
    adjustDateByView: p
  };
};
export {
  T as usePanelDateRange
};
